<script lang="ts">
  import Fa from 'svelte-fa';
  import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
  import { sortingIcon } from './utils';
  import type { FlatColumns } from '#lib/zod/output/TabularData.js';
  import type { SortState } from './state.svelte';

  let {
    col,
    sorting,
  }: {
    col: FlatColumns[0] | { type: 'name' };
    sorting: SortState;
  } = $props();

  const icon = $derived(sortingIcon(sorting ? (sorting.desc ? 'desc' : 'asc') : false, col));
</script>

<span class="inline-block w-5 *:inline-block">
  {#if sorting?.byPeak}
    <span class="w-1 align-top leading-1">
      <Fa icon={faAngleUp} size="xs" class="text-red-500" />
    </span>
  {/if}
  {#if icon}<Fa {icon} />{/if}
</span>
